import { BuiltinInterface } from '../BuiltinInterface';
class TypedPropertyDescriptorInterface extends BuiltinInterface {
    constructor() {
        super(...arguments);
        this.canImplement = true;
    }
}
export const add = (builtins) => {
    builtins.addInterface('TypedPropertyDescriptor', new TypedPropertyDescriptorInterface());
};

//# sourceMappingURL=index.js.map
